// このファイルは設計書（231 プログラム生成元ドキュメント）の表から生成した。手で直すときは設計書と突き合わせること。
// 02 バックエンド設計書 4.1（権限 130 件）・4.2（初期ロール）。人間レビュー必須（02 11.1 No.1）
// 274（10/14 ユーザー判断）：旧と同じく管理者以外のロールにも全ての権限を付けられるようにした（is_admin_fixed は全件 false）。
// 一般ユーザー（user）の初期の権限（is_user_granted）は変えていない。管理者（admin）は今どおり全権限固定（ADMIN_ROLE_PERMISSION_CODES）。
export const PERMISSION_DEFINITIONS = [
  {
    no: 1,
    permission_code: 'customers:read',
    resource_type: 'customers',
    action_type: 'read',
    meaning: '顧客（横断）の参照',
    is_user_granted: true,
    is_admin_fixed: false,
  },
  {
    no: 2,
    permission_code: 'customers:export',
    resource_type: 'customers',
    action_type: 'export',
    meaning: '顧客（横断）のファイル出力',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 3,
    permission_code: 'customers:import',
    resource_type: 'customers',
    action_type: 'import',
    meaning: '顧客（横断）の取込',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 4,
    permission_code: 'customers:bulkDelete',
    resource_type: 'customers',
    action_type: 'bulkDelete',
    meaning: '顧客（横断）の一括削除',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 5,
    permission_code: 'companies:create',
    resource_type: 'companies',
    action_type: 'create',
    meaning: '企業の登録',
    is_user_granted: true,
    is_admin_fixed: false,
  },
  {
    no: 6,
    permission_code: 'companies:read',
    resource_type: 'companies',
    action_type: 'read',
    meaning: '企業の参照',
    is_user_granted: true,
    is_admin_fixed: false,
  },
  {
    no: 7,
    permission_code: 'companies:update',
    resource_type: 'companies',
    action_type: 'update',
    meaning: '企業の変更',
    is_user_granted: true,
    is_admin_fixed: false,
  },
  {
    no: 8,
    permission_code: 'companies:delete',
    resource_type: 'companies',
    action_type: 'delete',
    meaning: '企業の削除',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 9,
    permission_code: 'companies:bulkDelete',
    resource_type: 'companies',
    action_type: 'bulkDelete',
    meaning: '企業の一括削除',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 10,
    permission_code: 'companies:restore',
    resource_type: 'companies',
    action_type: 'restore',
    meaning: '企業の復元',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 11,
    permission_code: 'companies:export',
    resource_type: 'companies',
    action_type: 'export',
    meaning: '企業のファイル出力',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 12,
    permission_code: 'sole_proprietors:create',
    resource_type: 'sole_proprietors',
    action_type: 'create',
    meaning: '個人事業主の登録',
    is_user_granted: true,
    is_admin_fixed: false,
  },
  {
    no: 13,
    permission_code: 'sole_proprietors:read',
    resource_type: 'sole_proprietors',
    action_type: 'read',
    meaning: '個人事業主の参照',
    is_user_granted: true,
    is_admin_fixed: false,
  },
  {
    no: 14,
    permission_code: 'sole_proprietors:update',
    resource_type: 'sole_proprietors',
    action_type: 'update',
    meaning: '個人事業主の変更',
    is_user_granted: true,
    is_admin_fixed: false,
  },
  {
    no: 15,
    permission_code: 'sole_proprietors:delete',
    resource_type: 'sole_proprietors',
    action_type: 'delete',
    meaning: '個人事業主の削除',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 16,
    permission_code: 'sole_proprietors:bulkDelete',
    resource_type: 'sole_proprietors',
    action_type: 'bulkDelete',
    meaning: '個人事業主の一括削除',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 17,
    permission_code: 'sole_proprietors:restore',
    resource_type: 'sole_proprietors',
    action_type: 'restore',
    meaning: '個人事業主の復元',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 18,
    permission_code: 'sole_proprietors:export',
    resource_type: 'sole_proprietors',
    action_type: 'export',
    meaning: '個人事業主のファイル出力',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 19,
    permission_code: 'customer_contacts:create',
    resource_type: 'customer_contacts',
    action_type: 'create',
    meaning: '企業担当者の登録',
    is_user_granted: true,
    is_admin_fixed: false,
  },
  {
    no: 20,
    permission_code: 'customer_contacts:read',
    resource_type: 'customer_contacts',
    action_type: 'read',
    meaning: '企業担当者の参照',
    is_user_granted: true,
    is_admin_fixed: false,
  },
  {
    no: 21,
    permission_code: 'customer_contacts:update',
    resource_type: 'customer_contacts',
    action_type: 'update',
    meaning: '企業担当者の変更',
    is_user_granted: true,
    is_admin_fixed: false,
  },
  {
    no: 22,
    permission_code: 'customer_contacts:delete',
    resource_type: 'customer_contacts',
    action_type: 'delete',
    meaning: '企業担当者の削除',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 23,
    permission_code: 'customer_contacts:restore',
    resource_type: 'customer_contacts',
    action_type: 'restore',
    meaning: '企業担当者の復元',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 24,
    permission_code: 'tags:read',
    resource_type: 'tags',
    action_type: 'read',
    meaning: 'タグの参照',
    is_user_granted: true,
    is_admin_fixed: false,
  },
  {
    no: 25,
    permission_code: 'cases:create',
    resource_type: 'cases',
    action_type: 'create',
    meaning: '案件の登録',
    is_user_granted: true,
    is_admin_fixed: false,
  },
  {
    no: 26,
    permission_code: 'cases:read',
    resource_type: 'cases',
    action_type: 'read',
    meaning: '案件の参照',
    is_user_granted: true,
    is_admin_fixed: false,
  },
  {
    no: 27,
    permission_code: 'cases:update',
    resource_type: 'cases',
    action_type: 'update',
    meaning: '案件の変更',
    is_user_granted: true,
    is_admin_fixed: false,
  },
  {
    no: 28,
    permission_code: 'cases:delete',
    resource_type: 'cases',
    action_type: 'delete',
    meaning: '案件の削除',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 29,
    permission_code: 'cases:bulkDelete',
    resource_type: 'cases',
    action_type: 'bulkDelete',
    meaning: '案件の一括削除',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 30,
    permission_code: 'cases:restore',
    resource_type: 'cases',
    action_type: 'restore',
    meaning: '案件の復元',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 31,
    permission_code: 'cases:export',
    resource_type: 'cases',
    action_type: 'export',
    meaning: '案件のファイル出力',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 32,
    permission_code: 'case_items:create',
    resource_type: 'case_items',
    action_type: 'create',
    meaning: '商品明細の登録',
    is_user_granted: true,
    is_admin_fixed: false,
  },
  {
    no: 33,
    permission_code: 'case_items:read',
    resource_type: 'case_items',
    action_type: 'read',
    meaning: '商品明細の参照',
    is_user_granted: true,
    is_admin_fixed: false,
  },
  {
    no: 34,
    permission_code: 'case_items:update',
    resource_type: 'case_items',
    action_type: 'update',
    meaning: '商品明細の変更',
    is_user_granted: true,
    is_admin_fixed: false,
  },
  {
    no: 35,
    permission_code: 'case_items:delete',
    resource_type: 'case_items',
    action_type: 'delete',
    meaning: '商品明細の削除',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 36,
    permission_code: 'case_items:restore',
    resource_type: 'case_items',
    action_type: 'restore',
    meaning: '商品明細の復元',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 37,
    permission_code: 'case_statuses:read',
    resource_type: 'case_statuses',
    action_type: 'read',
    meaning: '案件ステータス（マスタ）の参照',
    is_user_granted: true,
    is_admin_fixed: false,
  },
  {
    no: 38,
    permission_code: 'transactions:create',
    resource_type: 'transactions',
    action_type: 'create',
    meaning: '取引の登録',
    is_user_granted: true,
    is_admin_fixed: false,
  },
  {
    no: 39,
    permission_code: 'transactions:read',
    resource_type: 'transactions',
    action_type: 'read',
    meaning: '取引の参照',
    is_user_granted: true,
    is_admin_fixed: false,
  },
  {
    no: 40,
    permission_code: 'transactions:update',
    resource_type: 'transactions',
    action_type: 'update',
    meaning: '取引の変更',
    is_user_granted: true,
    is_admin_fixed: false,
  },
  {
    no: 41,
    permission_code: 'transactions:delete',
    resource_type: 'transactions',
    action_type: 'delete',
    meaning: '取引の削除',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 42,
    permission_code: 'transactions:bulkDelete',
    resource_type: 'transactions',
    action_type: 'bulkDelete',
    meaning: '取引の一括削除',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 43,
    permission_code: 'transactions:restore',
    resource_type: 'transactions',
    action_type: 'restore',
    meaning: '取引の復元',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 44,
    permission_code: 'transactions:export',
    resource_type: 'transactions',
    action_type: 'export',
    meaning: '取引のファイル出力',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 45,
    permission_code: 'transactions:revertPaymentStatus',
    resource_type: 'transactions',
    action_type: 'revertPaymentStatus',
    meaning: '取引の支払い状況の戻し',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 46,
    permission_code: 'transaction_statuses:read',
    resource_type: 'transaction_statuses',
    action_type: 'read',
    meaning: '取引ステータス（マスタ）の参照',
    is_user_granted: true,
    is_admin_fixed: false,
  },
  {
    no: 47,
    permission_code: 'activities:create',
    resource_type: 'activities',
    action_type: 'create',
    meaning: '活動履歴の登録',
    is_user_granted: true,
    is_admin_fixed: false,
  },
  {
    no: 48,
    permission_code: 'activities:read',
    resource_type: 'activities',
    action_type: 'read',
    meaning: '活動履歴の参照',
    is_user_granted: true,
    is_admin_fixed: false,
  },
  {
    no: 49,
    permission_code: 'activities:update',
    resource_type: 'activities',
    action_type: 'update',
    meaning: '活動履歴の変更',
    is_user_granted: true,
    is_admin_fixed: false,
  },
  {
    no: 50,
    permission_code: 'activities:delete',
    resource_type: 'activities',
    action_type: 'delete',
    meaning: '活動履歴の削除',
    is_user_granted: true,
    is_admin_fixed: false,
  },
  {
    no: 51,
    permission_code: 'activities:restore',
    resource_type: 'activities',
    action_type: 'restore',
    meaning: '活動履歴の復元',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 52,
    permission_code: 'calendar:read',
    resource_type: 'calendar',
    action_type: 'read',
    meaning: 'カレンダーの参照',
    is_user_granted: true,
    is_admin_fixed: false,
  },
  {
    no: 53,
    permission_code: 'goals:create',
    resource_type: 'goals',
    action_type: 'create',
    meaning: '目標の登録',
    is_user_granted: true,
    is_admin_fixed: false,
  },
  {
    no: 54,
    permission_code: 'goals:read',
    resource_type: 'goals',
    action_type: 'read',
    meaning: '目標の参照',
    is_user_granted: true,
    is_admin_fixed: false,
  },
  {
    no: 55,
    permission_code: 'goals:update',
    resource_type: 'goals',
    action_type: 'update',
    meaning: '目標の変更',
    is_user_granted: true,
    is_admin_fixed: false,
  },
  {
    no: 56,
    permission_code: 'goals:delete',
    resource_type: 'goals',
    action_type: 'delete',
    meaning: '目標の削除',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 57,
    permission_code: 'goals:bulkDelete',
    resource_type: 'goals',
    action_type: 'bulkDelete',
    meaning: '目標の一括削除',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 58,
    permission_code: 'goals:restore',
    resource_type: 'goals',
    action_type: 'restore',
    meaning: '目標の復元',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 59,
    permission_code: 'dashboard:read',
    resource_type: 'dashboard',
    action_type: 'read',
    meaning: 'ダッシュボードの参照',
    is_user_granted: true,
    is_admin_fixed: false,
  },
  {
    no: 60,
    permission_code: 'reports:read',
    resource_type: 'reports',
    action_type: 'read',
    meaning: 'レポート・集計の参照',
    is_user_granted: true,
    is_admin_fixed: false,
  },
  {
    no: 61,
    permission_code: 'reports:export',
    resource_type: 'reports',
    action_type: 'export',
    meaning: 'レポート・集計のファイル出力',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 62,
    permission_code: 'report_templates:create',
    resource_type: 'report_templates',
    action_type: 'create',
    meaning: 'レポート雛形の登録',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 63,
    permission_code: 'report_templates:read',
    resource_type: 'report_templates',
    action_type: 'read',
    meaning: 'レポート雛形の参照',
    is_user_granted: true,
    is_admin_fixed: false,
  },
  {
    no: 64,
    permission_code: 'report_templates:update',
    resource_type: 'report_templates',
    action_type: 'update',
    meaning: 'レポート雛形の変更',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 65,
    permission_code: 'report_templates:delete',
    resource_type: 'report_templates',
    action_type: 'delete',
    meaning: 'レポート雛形の削除',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 66,
    permission_code: 'report_templates:restore',
    resource_type: 'report_templates',
    action_type: 'restore',
    meaning: 'レポート雛形の復元',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 67,
    permission_code: 'personnel:create',
    resource_type: 'personnel',
    action_type: 'create',
    meaning: '要員の登録',
    is_user_granted: true,
    is_admin_fixed: false,
  },
  {
    no: 68,
    permission_code: 'personnel:read',
    resource_type: 'personnel',
    action_type: 'read',
    meaning: '要員の参照',
    is_user_granted: true,
    is_admin_fixed: false,
  },
  {
    no: 69,
    permission_code: 'personnel:update',
    resource_type: 'personnel',
    action_type: 'update',
    meaning: '要員の変更',
    is_user_granted: true,
    is_admin_fixed: false,
  },
  {
    no: 70,
    permission_code: 'personnel:delete',
    resource_type: 'personnel',
    action_type: 'delete',
    meaning: '要員の削除',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 71,
    permission_code: 'personnel:bulkDelete',
    resource_type: 'personnel',
    action_type: 'bulkDelete',
    meaning: '要員の一括削除',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 72,
    permission_code: 'personnel:restore',
    resource_type: 'personnel',
    action_type: 'restore',
    meaning: '要員の復元',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 73,
    permission_code: 'personnel:export',
    resource_type: 'personnel',
    action_type: 'export',
    meaning: '要員のファイル出力',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 74,
    permission_code: 'personnel:import',
    resource_type: 'personnel',
    action_type: 'import',
    meaning: '要員の取込',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 75,
    permission_code: 'contracts:create',
    resource_type: 'contracts',
    action_type: 'create',
    meaning: '契約の登録',
    is_user_granted: true,
    is_admin_fixed: false,
  },
  {
    no: 76,
    permission_code: 'contracts:read',
    resource_type: 'contracts',
    action_type: 'read',
    meaning: '契約の参照',
    is_user_granted: true,
    is_admin_fixed: false,
  },
  {
    no: 77,
    permission_code: 'contracts:update',
    resource_type: 'contracts',
    action_type: 'update',
    meaning: '契約の変更',
    is_user_granted: true,
    is_admin_fixed: false,
  },
  {
    no: 78,
    permission_code: 'contracts:delete',
    resource_type: 'contracts',
    action_type: 'delete',
    meaning: '契約の削除',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 79,
    permission_code: 'contracts:bulkDelete',
    resource_type: 'contracts',
    action_type: 'bulkDelete',
    meaning: '契約の一括削除',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 80,
    permission_code: 'contracts:restore',
    resource_type: 'contracts',
    action_type: 'restore',
    meaning: '契約の復元',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 81,
    permission_code: 'contracts:export',
    resource_type: 'contracts',
    action_type: 'export',
    meaning: '契約のファイル出力',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 82,
    permission_code: 'contracts:import',
    resource_type: 'contracts',
    action_type: 'import',
    meaning: '契約の取込',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 83,
    permission_code: 'checklist_templates:create',
    resource_type: 'checklist_templates',
    action_type: 'create',
    meaning: 'チェックリスト雛形の登録',
    is_user_granted: true,
    is_admin_fixed: false,
  },
  {
    no: 84,
    permission_code: 'checklist_templates:read',
    resource_type: 'checklist_templates',
    action_type: 'read',
    meaning: 'チェックリスト雛形の参照',
    is_user_granted: true,
    is_admin_fixed: false,
  },
  {
    no: 85,
    permission_code: 'checklist_templates:update',
    resource_type: 'checklist_templates',
    action_type: 'update',
    meaning: 'チェックリスト雛形の変更',
    is_user_granted: true,
    is_admin_fixed: false,
  },
  {
    no: 86,
    permission_code: 'monthly_checklists:create',
    resource_type: 'monthly_checklists',
    action_type: 'create',
    meaning: '月次チェックリストの登録',
    is_user_granted: true,
    is_admin_fixed: false,
  },
  {
    no: 87,
    permission_code: 'monthly_checklists:read',
    resource_type: 'monthly_checklists',
    action_type: 'read',
    meaning: '月次チェックリストの参照',
    is_user_granted: true,
    is_admin_fixed: false,
  },
  {
    no: 88,
    permission_code: 'monthly_checklists:update',
    resource_type: 'monthly_checklists',
    action_type: 'update',
    meaning: '月次チェックリストの変更',
    is_user_granted: true,
    is_admin_fixed: false,
  },
  {
    no: 89,
    permission_code: 'monthly_checklists:export',
    resource_type: 'monthly_checklists',
    action_type: 'export',
    meaning: '月次チェックリストのファイル出力',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 90,
    permission_code: 'monthly_checklists:import',
    resource_type: 'monthly_checklists',
    action_type: 'import',
    meaning: '月次チェックリストの取込',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 91,
    permission_code: 'forms:create',
    resource_type: 'forms',
    action_type: 'create',
    meaning: 'フォーム定義の登録',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 92,
    permission_code: 'forms:read',
    resource_type: 'forms',
    action_type: 'read',
    meaning: 'フォーム定義の参照',
    is_user_granted: true,
    is_admin_fixed: false,
  },
  {
    no: 93,
    permission_code: 'forms:update',
    resource_type: 'forms',
    action_type: 'update',
    meaning: 'フォーム定義の変更',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 94,
    permission_code: 'forms:delete',
    resource_type: 'forms',
    action_type: 'delete',
    meaning: 'フォーム定義の削除',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 95,
    permission_code: 'forms:restore',
    resource_type: 'forms',
    action_type: 'restore',
    meaning: 'フォーム定義の復元',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 96,
    permission_code: 'form_submissions:read',
    resource_type: 'form_submissions',
    action_type: 'read',
    meaning: 'フォーム回答の参照',
    is_user_granted: true,
    is_admin_fixed: false,
  },
  {
    no: 97,
    permission_code: 'form_submissions:markRead',
    resource_type: 'form_submissions',
    action_type: 'markRead',
    meaning: 'フォーム回答の既読化',
    is_user_granted: true,
    is_admin_fixed: false,
  },
  {
    no: 98,
    permission_code: 'form_submissions:reply',
    resource_type: 'form_submissions',
    action_type: 'reply',
    meaning: 'フォーム回答の返信',
    is_user_granted: true,
    is_admin_fixed: false,
  },
  {
    no: 99,
    permission_code: 'form_submissions:linkCustomer',
    resource_type: 'form_submissions',
    action_type: 'linkCustomer',
    meaning: 'フォーム回答の顧客紐付け',
    is_user_granted: true,
    is_admin_fixed: false,
  },
  {
    no: 100,
    permission_code: 'form_submissions:update',
    resource_type: 'form_submissions',
    action_type: 'update',
    meaning: 'フォーム回答の変更',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 101,
    permission_code: 'form_submissions:delete',
    resource_type: 'form_submissions',
    action_type: 'delete',
    meaning: 'フォーム回答の削除',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 102,
    permission_code: 'form_submissions:restore',
    resource_type: 'form_submissions',
    action_type: 'restore',
    meaning: 'フォーム回答の復元',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 103,
    permission_code: 'form_submissions:export',
    resource_type: 'form_submissions',
    action_type: 'export',
    meaning: 'フォーム回答のファイル出力',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 104,
    permission_code: 'contact_threads:create',
    resource_type: 'contact_threads',
    action_type: 'create',
    meaning: 'コンタクトの登録',
    is_user_granted: true,
    is_admin_fixed: false,
  },
  {
    no: 105,
    permission_code: 'contact_threads:read',
    resource_type: 'contact_threads',
    action_type: 'read',
    meaning: 'コンタクトの参照',
    is_user_granted: true,
    is_admin_fixed: false,
  },
  {
    no: 106,
    permission_code: 'contact_threads:delete',
    resource_type: 'contact_threads',
    action_type: 'delete',
    meaning: 'コンタクトの削除',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 107,
    permission_code: 'contact_threads:restore',
    resource_type: 'contact_threads',
    action_type: 'restore',
    meaning: 'コンタクトの復元',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 108,
    permission_code: 'attachments:create',
    resource_type: 'attachments',
    action_type: 'create',
    meaning: '添付ファイルの登録',
    is_user_granted: true,
    is_admin_fixed: false,
  },
  {
    no: 109,
    permission_code: 'attachments:read',
    resource_type: 'attachments',
    action_type: 'read',
    meaning: '添付ファイルの参照',
    is_user_granted: true,
    is_admin_fixed: false,
  },
  {
    no: 110,
    permission_code: 'attachments:delete',
    resource_type: 'attachments',
    action_type: 'delete',
    meaning: '添付ファイルの削除',
    is_user_granted: true,
    is_admin_fixed: false,
  },
  {
    no: 111,
    permission_code: 'attachments:restore',
    resource_type: 'attachments',
    action_type: 'restore',
    meaning: '添付ファイルの復元',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 112,
    permission_code: 'users:create',
    resource_type: 'users',
    action_type: 'create',
    meaning: '利用者の登録',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 113,
    permission_code: 'users:read',
    resource_type: 'users',
    action_type: 'read',
    meaning: '利用者の参照',
    is_user_granted: true,
    is_admin_fixed: false,
  },
  {
    no: 114,
    permission_code: 'users:update',
    resource_type: 'users',
    action_type: 'update',
    meaning: '利用者の変更',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 115,
    permission_code: 'users:delete',
    resource_type: 'users',
    action_type: 'delete',
    meaning: '利用者の削除',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 116,
    permission_code: 'users:bulkDelete',
    resource_type: 'users',
    action_type: 'bulkDelete',
    meaning: '利用者の一括削除',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 117,
    permission_code: 'users:restore',
    resource_type: 'users',
    action_type: 'restore',
    meaning: '利用者の復元',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 118,
    permission_code: 'users:export',
    resource_type: 'users',
    action_type: 'export',
    meaning: '利用者のファイル出力',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 119,
    permission_code: 'roles:create',
    resource_type: 'roles',
    action_type: 'create',
    meaning: 'ロールの登録',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 120,
    permission_code: 'roles:read',
    resource_type: 'roles',
    action_type: 'read',
    meaning: 'ロールの参照',
    is_user_granted: true,
    is_admin_fixed: false,
  },
  {
    no: 121,
    permission_code: 'roles:update',
    resource_type: 'roles',
    action_type: 'update',
    meaning: 'ロールの変更',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 122,
    permission_code: 'roles:delete',
    resource_type: 'roles',
    action_type: 'delete',
    meaning: 'ロールの削除',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 123,
    permission_code: 'roles:bulkDelete',
    resource_type: 'roles',
    action_type: 'bulkDelete',
    meaning: 'ロールの一括削除',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 124,
    permission_code: 'roles:restore',
    resource_type: 'roles',
    action_type: 'restore',
    meaning: 'ロールの復元',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 125,
    permission_code: 'system_settings:read',
    resource_type: 'system_settings',
    action_type: 'read',
    meaning: '自社設定の参照',
    is_user_granted: true,
    is_admin_fixed: false,
  },
  {
    no: 126,
    permission_code: 'system_settings:update',
    resource_type: 'system_settings',
    action_type: 'update',
    meaning: '自社設定の変更',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 127,
    permission_code: 'numbering_rules:read',
    resource_type: 'numbering_rules',
    action_type: 'read',
    meaning: '採番ルールの参照',
    is_user_granted: true,
    is_admin_fixed: false,
  },
  {
    no: 128,
    permission_code: 'numbering_rules:update',
    resource_type: 'numbering_rules',
    action_type: 'update',
    meaning: '採番ルールの変更',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 129,
    permission_code: 'audit_logs:read',
    resource_type: 'audit_logs',
    action_type: 'read',
    meaning: '監査ログの参照',
    is_user_granted: false,
    is_admin_fixed: false,
  },
  {
    no: 130,
    permission_code: 'audit_logs:export',
    resource_type: 'audit_logs',
    action_type: 'export',
    meaning: '監査ログのファイル出力',
    is_user_granted: false,
    is_admin_fixed: false,
  },
] as const;

export type PermissionDefinition = (typeof PERMISSION_DEFINITIONS)[number];
export type PermissionCode = PermissionDefinition['permission_code'];

export const PERMISSION_CODES = PERMISSION_DEFINITIONS.map((p) => p.permission_code) as unknown as readonly [
  PermissionCode,
  ...PermissionCode[],
];

/** 操作（action_type）の日本語名（API-USER-16 の action_name） */
export const ACTION_TYPE_NAMES: Readonly<Record<string, string>> = {
  read: '参照',
  create: '登録',
  update: '変更',
  delete: '削除',
  bulkDelete: '一括削除',
  restore: '復元',
  export: 'ファイル出力',
  import: '取込',
  markRead: '既読化',
  reply: '返信',
  linkCustomer: '顧客への紐付け',
  revertPaymentStatus: '支払い状況の戻し',
};

/** 対象（resource_type）の日本語名（API-USER-16 の resource_name。4.1 の「意味」列から取り出した） */
export const RESOURCE_TYPE_NAMES: Readonly<Record<string, string>> = {
  customers: '顧客（横断）',
  companies: '企業',
  sole_proprietors: '個人事業主',
  customer_contacts: '企業担当者',
  tags: 'タグ',
  cases: '案件',
  case_items: '商品明細',
  case_statuses: '案件ステータス（マスタ）',
  transactions: '取引',
  transaction_statuses: '取引ステータス（マスタ）',
  activities: '活動履歴',
  calendar: 'カレンダー',
  goals: '目標',
  dashboard: 'ダッシュボード',
  reports: 'レポート・集計',
  report_templates: 'レポート雛形',
  personnel: '要員',
  contracts: '契約',
  checklist_templates: 'チェックリスト雛形',
  monthly_checklists: '月次チェックリスト',
  forms: 'フォーム定義',
  form_submissions: 'フォーム回答',
  contact_threads: 'コンタクト',
  attachments: '添付ファイル',
  users: '利用者',
  roles: 'ロール',
  system_settings: '自社設定',
  numbering_rules: '採番ルール',
  audit_logs: '監査ログ',
};
